"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheDhtpropertiesMission() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="the-dhtproperties-mission" className="w-full bg-background">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[80vh]">
        {}
        <div className="relative w-full h-[50vh] lg:h-auto bg-muted">
          <img src="https://newchapterpropertysolutions.com/wp-content/uploads/2026/03/liftapp-3.png" alt="DHTproperties Founders" className="absolute inset-0 w-full h-full object-cover grayscale contrast-125" />
        </div>

        {}
        <div className="flex flex-col justify-center p-8 md:p-16 lg:p-24 xl:p-32 bg-background">
          <div ref={contentRef} className={`max-w-2xl transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <span className="block text-sm font-bold tracking-widest uppercase text-primary mb-6">
              Our Mission
            </span>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-foreground mb-10 leading-[1.1]">
              Redefining Real Estate Transactions.
            </h2>
            
            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
              <p>At New Chapter Property Solutions, our mission is simple: to provide homeowners with a frictionless, transparent, and reliable way to sell their properties. We have been in business for 20 years in the Cincinnati area, truly making a difference in the communities that we love by providing outstanding solution-based services that truly change lives.</p>
              <p>
                We do not just buy houses; we provide solutions. Whether you are facing foreclosure, managing an inherited property, or simply need to move quickly without the burden of repairs, our team is committed to delivering a fair cash offer and a seamless closing process.
              </p>
              <p>We believe in architectural trust. No hidden fees. No realtor commissions. Just a straightforward, professional transaction where we are the buyers so you don't have to worry about a lengthy process</p>
            </div>

            <div className="mt-16 pt-10 border-t border-border">
              <p className="font-serif text-4xl italic text-foreground mb-2">Darin Bowling</p>
              <p className="text-sm font-medium text-muted-foreground uppercase tracking-widest">
                Founder & Lead Investor
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}